import React from 'react';
import BotInputControl from './ctrl_input';
import Button from '../../../../../../controls/button';
import './style.scss';

class BotInputsControl extends React.Component {
    constructor(props) {
        super(props);

        let inputs = [];
        this.props.inputs.forEach(i => {
            inputs.push({
                id: i.id,
                text: i.text,
                value: '',
                isValid: i.type ? false : true
            });
        });
        this.state = {
            isAllValid: false,
            inputs: inputs
        };
    }

    isValid(id, text, value, isValid) {
        let inputs = this.state.inputs;
        inputs.forEach(i => {
            if (i.id == id) {
                i.value = value;
                i.isValid = isValid;
            }
        });
        this.setState({
            isAllValid: this.isAllValid(inputs),
            inputs: inputs
        });
    }

    isAllValid(inputs) {
        let isValid = true;
        inputs.forEach(i => {
            if (i.isValid == false) {
                isValid = false;
            }
        });
        return isValid;
    }

    getResponse() {
        let response = [];
        this.state.inputs.forEach(i => {
            response.push({
                id: i.id,
                text: i.text,
                value: i.value
            });
        });
        return response;
    }

    onSubmit() {
        this.props.onSubmit(this.getResponse());
    }

    render() {
        const inputs = this.props.inputs
            ? this.props.inputs.map((input, i) => (
                <div key={i} className="botInput">
                    <BotInputControl
                        id={input.id}
                        enabled={this.props.enabled}
                        validationType={input.type}
                        onChange={(value, isValid) =>
                            this.isValid(input.id, input.text, value, isValid)
                        }
                    />
                </div>
            ))
            : null;

        return (
            <div className="botInputs">
                {
                    <div>
                        {inputs}
                        <Button
                            className="white"
                            disabled={!(this.props.enabled && this.state.isAllValid)}
                            text="Potwierdź"
                            onClick={() => this.onSubmit()}
                        />
                    </div>
                }
            </div>
        );
    }
}

export default BotInputsControl;

export const botAnswerToText = response => {
    let text = '';
    response.forEach(r => {
        text += r.text + ': ' + r.value + ', ';
    });
    return text.substring(0, text.length - 2) + '.';
};

export const botAnswerToBotResponse = response => {
    let inputs = [];

    response.value.forEach(i => {
        inputs.push({
            id: i.id,
            value: i.value
        });
    });

    return {
        ...response,
        value: inputs
    };
};

export const botQuestionToText = value => {
    let text = '';
    if (value) {
        text += 'Pola formularza: ';
        value.forEach(input => {
            text += input.text + ', ';
        });
        text = text.substring(0, text.length - 2) + '.';
    }
    return text;
};
